export default {
    pleaseInput: '请输入',
    file: '附件',
    send: '发送',
    loadAll: '已加载全部',
    expand: '展开',
    collapse: '收起',
    reply: '回复',
    comment: '评论',
    selected: '已选择',
    person: '人',
    sure: '确定',
    writeComment: '写评论',
    choose: '请选择要@的人',
    imageTips1: '最多可上传8个文件/图片',
    uploadFail: '文件上传失败',
    imageTips2: '不支持{text}文件',
    moreThan: '图片/文件大小超过5M',
    contentNoEmpty: '评论内容不允许为空',
    replyNoEmpty: '回复内容不允许为空',
    sureDeleteComment: '确定删除这条评论吗？',
    deleteCommentSuccess: '删除评论成功!',
    deleteCommentFailed: '删除评论失败!',
};
